const COURIER_MOTIVO_KEYS = [
  "sample",
  "leftWithClient",
  "swatch",
  "color",
  "card",
  "other",
];

/** Motivo sample (o legado TON). */
export function isCourierSampleMotivo(motivo = "") {
  const m = String(motivo || "")
    .trim()
    .toLowerCase();
  if (!m) return false;
  if (m === "sample") return true;
  if (m === "leftwithclient" || m === "left_with_client") return true;
  if (m.includes("movimiento de muestra")) return true;
  if (m.includes("envío de muestra") || m.includes("envio de muestra")) {
    return true;
  }
  if (m.includes("queda en cliente") || m.includes("deja en cliente")) {
    return true;
  }
  return false;
}

/**
 * Temporada/Marca/… solo con Motivo muestra (o legado TON) y código/id.
 * Swatch / color / card / other → ocultos (usar shouldShowPieceMetaFields).
 */
export function shouldShowSampleDetails(linea = {}) {
  const m = String(linea.Motivo || "")
    .trim()
    .toLowerCase();
  if (["swatch", "color", "card", "other"].includes(m)) return false;
  if (m && !isCourierSampleMotivo(m)) return false;
  if (!isCourierSampleMotivo(m) && !m) {
    // Motivo vacío: solo si ya viene de TON (legado sin Motivo normalizado)
    if (
      !linea.IdMovimientoMuestra &&
      !linea.IdMuestra &&
      !String(linea.CodigoMuestra || "").trim()
    ) {
      return false;
    }
  }
  return Boolean(
    linea.IdMuestra ||
    linea.IdMovimientoMuestra ||
    String(linea.CodigoMuestra || "").trim(),
  );
}

/** Meta (temporada/marca/…) también en piezas no-muestra (swatch, color…). */
export function shouldShowPieceMetaFields(linea = {}) {
  const m = String(linea.Motivo || "")
    .trim()
    .toLowerCase();
  if (["swatch", "color", "card", "other"].includes(m)) return true;
  if (String(linea.Estilo || "").trim() && !isCourierSampleMotivo(m)) {
    return true;
  }
  return shouldShowSampleDetails(linea);
}

/** Meta de TON (muestra vinculada) es solo lectura; el resto editable. */
export function isPieceMetaReadOnly(linea = {}) {
  if (!(linea.IdMuestra || linea.IdMovimientoMuestra)) return false;
  return isCourierSampleMotivo(linea.Motivo);
}

/** Valor de Motivo para el select (legado TON → sample / leftWithClient). */
export function normalizeCourierMotivoValue(motivo = "") {
  const raw = String(motivo || "").trim();
  if (!raw) return "sample";
  if (COURIER_MOTIVO_KEYS.includes(raw)) return raw;
  const lower = raw.toLowerCase();
  if (
    lower === "left_with_client" ||
    lower.includes("queda en cliente") ||
    lower.includes("deja en cliente")
  ) {
    return "leftWithClient";
  }
  if (isCourierSampleMotivo(raw)) return "sample";
  return raw;
}

/**
 * Corrige Motivo de línea si el envío es «Se queda en Cliente» pero la línea
 * quedó como sample (p. ej. sobrescritura por autofill de TON).
 */
export function healCourierLineMotivo(linea = {}, envioOrNotas = {}) {
  const notas =
    typeof envioOrNotas === "string"
      ? envioOrNotas
      : String(envioOrNotas?.Notas || "");
  const normalized = normalizeCourierMotivoValue(linea.Motivo);
  if (normalized === "leftWithClient") {
    return { ...linea, Motivo: "leftWithClient" };
  }
  const notasLeave =
    notas.toLowerCase().includes("queda en cliente") ||
    notas.toLowerCase().includes("deja en cliente") ||
    notas.toLowerCase().replace(/_/g, "") === "leftwithclient";
  if (
    notasLeave &&
    (normalized === "sample" || !String(linea.Motivo || "").trim())
  ) {
    return { ...linea, Motivo: "leftWithClient" };
  }
  return linea;
}

export function sampleDetailsChanged(linea = {}, fields = {}) {
  const keys = [
    "Temporada",
    "Marca",
    "TipoPrenda",
    "TipoMuestra",
    "Tejido",
    "Color",
    "Talla",
    "CodigoMuestra",
    "IdMuestra",
    "Motivo",
  ];
  return keys.some((k) => String(linea[k] ?? "") !== String(fields[k] ?? ""));
}
